import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { ChangeEvent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDebounce } from '../../../hooks/useDebounce';
import { IUserBasic } from '../../../interfaces/IUserBasic';
import api from '../../../newApi/apiNet';
import { PulseLoader } from '../../loaders/PulseLoader';

export const AccountManagementRoleSearchUser = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [searchResult, setSearchResult] = useState<IUserBasic[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const debounceSearchQuery = useDebounce(searchQuery, 1000);

    const handleSearchQueryInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const searchQuery = e.target.value;
        setSearchQuery(searchQuery);
    };
    useEffect(() => {
        if (debounceSearchQuery.length >= 1) {
            setIsErrorVisible(false);
            (async () => {
                setIsLoading(true);
                const result = await api.getSearchedUsersWithRoles(debounceSearchQuery);
                setSearchResult(result.data);
                setIsLoading(false);
            })();
        } else {
            if (searchQuery.length >= 1)
                setIsErrorVisible(true);
        }
    }, [debounceSearchQuery, searchQuery.length]);

    return (
        <div className="max-w-lg mt-4 animate-opacityEaseIn">
            <h1 className="text-3xl mb-3 font-medium">Dodaj uprawnienia</h1>
            <div className="h-0.5 w-28 bg-sky-500 my-4 rounded-r-full" />
            <label>
                <p className="py-1 font-medium text-lg">ID użytkownika</p>
                <input type="text"
                       className={'w-full px-4 py-3 text-xl rounded-lg text-neutral-800 focus:outline-hidden placeholder:text-neutral-200'}
                       placeholder={'Wprowadź ID użytkownika'}
                       value={searchQuery}
                       onInput={handleSearchQueryInputChange} />
            </label>
            {isErrorVisible && <p className="text-red-500 mt-2">Wprowadź co najmniej 3 znaki</p>}
            {(debounceSearchQuery.length >= 1 || searchResult.length > 0) &&
                <p className="animate-opacityEaseIn text-xl font-medium my-4">Wyniki wyszukiwania</p>}
            {searchResult && !isLoading &&
                <div className="space-y-2">
                    {searchResult.map(item =>
                        <div key={item.id}
                             className="animate-opacityEaseIn relative py-5 px-6 text-neutral-100 bg-neutral-900 rounded-2xl flex justify-between items-center group hover:bg-neutral-700 transition-colors duration-150">
                            <p>{item.customerId}</p>
                            <ChevronRightIcon className="w-6 h-6" />
                            <Link to={`/ustawienia/uprawnienia/uzytkownik/${item.id}`} className="absolute inset-0" />
                        </div>,
                    )}
                </div>
            }
            {searchResult.length === 0 && !isLoading && debounceSearchQuery.length >= 1 &&
                <p className="text-center text-neutral-400">Brak wyników</p>
            }
            {isLoading &&
                <PulseLoader description="Ładowanie ..." />}
        </div>
    );
};
